import { HttpClient } from 'shared/libs/http';
import type { LoginResponse, User } from 'user/types';

export type CreateResumeProfileAccess = {
   allowed: boolean;
   missingFields: CreateResumeProfileField[];
   user: User | null;
};

export type CreateResumeProfileField = 'birthday' | 'country' | 'city';

export const CREATE_RESUME_PROFILE_FIELD_LABELS: Record<CreateResumeProfileField, string> = {
   birthday: 'Дата народження',
   country: 'Країна',
   city: 'Місто',
};

const hasValue = (value: unknown): boolean => {
   if (value === null || value === undefined) {
      return false;
   }

   if (typeof value === 'string') {
      return value.trim().length > 0;
   }

   return true;
};

export const getCreateResumeProfileMissingFields = (user: User): CreateResumeProfileField[] => {
   const city = user.city ?? user.city_id;
   const country = user.country;
   const birthday = user.birthday;
   const missingFields: CreateResumeProfileField[] = [];

   if (!hasValue(birthday)) {
      missingFields.push('birthday');
   }

   if (!hasValue(country)) {
      missingFields.push('country');
   }

   if (!hasValue(city)) {
      missingFields.push('city');
   }

   return missingFields;
};

export const isCreateResumeProfileFilled = (user: User): boolean => {
   return getCreateResumeProfileMissingFields(user).length === 0;
};

export const loadCreateResumeProfileAccess = async (): Promise<CreateResumeProfileAccess> => {
   const response = await HttpClient.post<LoginResponse>('/users/login-token', null);

   if (response.status !== 200) {
      return {
         allowed: false,
         missingFields: [],
         user: null,
      };
   }

   const missingFields = getCreateResumeProfileMissingFields(response.response.user);

   return {
      allowed: missingFields.length === 0,
      missingFields,
      user: response.response.user,
   };
};
